<div class="min-h-screen bg-background flex flex-col items-center justify-between">
  <!-- Header -->
  <header class="w-full flex justify-between items-center p-6 gap-4 border-b border-border shadow-sm">
    <!-- Theme Toggle -->
    <div class="flex items-center gap-3">
      <span class="flex items-center gap-2">
        <i class="ki-filled ki-moon text-lg text-muted-foreground"></i>
        <span class="font-medium text-sm text-foreground">Dark Mode</span>
      </span>
      <input class="kt-switch kt-switch-sm" 
             type="checkbox" 
             [checked]="themeService.effectiveTheme() === 'dark'"
             (change)="onThemeToggle($event)"
             name="theme-toggle" 
             value="1"/>
    </div>

    <!-- Auth Actions -->
    <div class="flex items-center gap-4">
      @if (authService.currentUser$ | async; as user) {
         <span class="text-sm font-medium text-foreground">Welcome, {{ user.username }}</span>
         <button (click)="logout()" class="kt-btn kt-btn-outline kt-btn-sm">Logout</button>
      } @else {
         <a routerLink="/auth/sign-in" class="kt-btn kt-btn-outline kt-btn-sm">Sign In</a>
         <a routerLink="/auth/sign-up" class="kt-btn kt-btn-primary kt-btn-sm">Sign Up</a>
      }
    </div>
  </header>

  <!-- Main Content -->
  <main class="flex-grow flex flex-col justify-center items-center p-6 text-center">
    @if (authService.currentUser$ | async; as user) {
      <h2 class="text-xl md:text-3xl text-secondary-foreground font-medium mb-4">
        Welcome <span class="text-primary font-semibold">{{ user.username }}</span>!
      </h2>
    }
    
    <img [src]="themeService.effectiveTheme() === 'dark' ? '/assets/media/app/logo_dark.png' : '/assets/media/app/logo.png'" alt="Veraxum Logo" class="h-32 mb-8" />
    <h1 class="text-6xl md:text-8xl font-bold tracking-tight text-foreground" style="font-family: 'Inter', sans-serif;">
      Veraxum
    </h1>
    <p class="mt-4 text-muted-foreground text-lg md:text-2xl max-w-xl">
      Explainable AI Platform
    </p>
  </main>
  
  <footer class="w-full text-center p-4 text-sm text-secondary-foreground border-t border-border mt-auto">
      &copy; 2026 Veraxum. All rights reserved.
  </footer>
</div>
